export type { EventsPageProps } from "./EventsPage";
export { EventsPage } from "./EventsPage";
